module.exports = __webpack_public_path__ + "img/boy-torso-front.31a05429.png";